module.exports = __webpack_public_path__ + "static/media/ts15cr0.d18e70bf.png";